<script lang="js">
import { mapGetters } from "vuex";

export default {
    name: "Dashboard",
    data() {
        return {
            notifications: [
                {
                  id: 1,
                    title: "Portal Dues Owed",
                    message:
                        "You have not paid your portal fees for this session. Please click below to pay as soon as possible.",
                    link: "",
                    date: "2025-02-10T12:00:00Z",
                },
                {
                  id: 2,
                    title: "Complete application form",
                    message:
                        "You have not completed your application form. Please click below to complete as soon as possible.",
                    link: "/app/appForm",
                    date: "2025-02-04T12:00:00Z",
                },
                {
                  id: 3,
                    title: "Application Dues Owed",
                    message:
                        "You have not paid your application fees for this session. Please click below to pay as soon as possible.",
                    link: "",
                    date: "2025-01-04T12:00:00Z",
                },
            ],
            upcomingEvents: [
                {
                    title: "MSA Career Expo 1.0",
                    organizer: "Management Students' Association",
                    date: "March 6",
                    time: "10:00 AM",
                    venue: "First City Poly Auditorium",
                    image: "https://img.freepik.com/premium-vector/trendy-event-banner-template_85212-590.jpg",
                },
                {
                    title: "Tech Conference 2024",
                    organizer: "Tech Enthusiasts Club",
                    date: "April 12",
                    time: "2:00 PM",
                    venue: "Innovation Hub",
                    image: "https://d1xv5jidmf7h0f.cloudfront.net/circleone/images/mastertemplates/10369/preview_page_1.jpg",
                },
                {
                    title: "Entrepreneurship Bootcamp",
                    organizer: "Business Leaders Society",
                    date: "May 20",
                    time: "9:00 AM",
                    venue: "Main Hall",
                    image: "https://img.freepik.com/free-psd/event-banner-template-design_23-2149231981.jpg",
                },
            ],
            courses: [
                { code: "ACC120", title: "Introduction to Cost Accounting", credit: 3, type: "Compulsory" },
                { code: "FIN120", title: "Banking and Finance", credit: 3, type: "Compulsory" },
                { code: "BUS120", title: "Business Strategies", credit: 3, type: "Elective" }
            ]
        };
    },
    mounted() {
    },
    computed: {
    ...mapGetters(["getUser"]), // Access user data
    user() {
      return this.getUser;
    },
  },
    methods: {
        addCourse() {
            this.courses.push({
                code: "NEW101",
                title: "Newly Added Course",
                credit: 2,
                type: "Elective"
            });
        },
        removeCourse() {
            if (this.courses.length > 0) {
                this.courses.pop();
            }
        },
        truncateMessage(message) {
    return message.length > 50 ? message.slice(0, 50) + "..." : message;
  },
  timeAgo(dateString) {
      const now = new Date();
      const date = new Date(dateString);
      const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

      if (diffInDays >= 7) {
        const weeks = Math.floor(diffInDays / 7);
        return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
      } else {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
      }
    }
    },
    components: {},
};
</script>

<template>
  <div class="p-4 text-start">
    <h4 class="fw-bold">Dashboard</h4>
    <hr />

    <div class="row my-5">
      <h6>Notifications</h6>
      <div class="d-flex overflow-x-scroll py-2">
        <div
          class="col-md-2 flex-shrink-0 me-4"
          v-for="(notification, index) in notifications"
          :key="index"
        >
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-header bg-white border-bottom-0">
              <i class="bi bi-exclamation-triangle-fill me-1"></i>
              <span style="font-size: small">{{ notification.title }}</span>
            </div>
            <div class="card-body py-0">
              <span class="text-muted" style="font-size: small">
                {{ truncateMessage(notification.message) }}
              </span>
            </div>
            <div
              class="card-footer bg-white border-top-0 d-flex align-items-center justify-content-between"
            >
              <div>
                <i class="bi bi-clock me-1 text-muted"></i>
                <span class="text-muted" style="font-size: small">{{
                  timeAgo(notification.date)
                }}</span>
              </div>
              <RouterLink
                class="text-decoration-none float-end d-flex align-items-center"
                style="font-size: small"
                :to="notification.link"
              >
                See more <i class="bi bi-caret-down-square-fill ms-1"></i>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4 mb-5">
      <div class="col-md-6 col-lg-3">
        <h6>Biodata</h6>
        <div class="card border-0 shadow-sm" style="min-height: 400px">
          <div
            class="card-header bg-white border-bottom-0 text-end text-secondary"
            style="font-size: small"
          >
            Edit
          </div>
          <div class="card-img-top d-flex justify-content-center">
            <img
              src="https://fakeimg.pl/200x200/ff7b00/ffffff?text=User"
              class="rounded-circle"
              width="130"
              height="130"
              alt="User's image"
            />
          </div>
          <div class="card-body">
            <h6 class="text-center" style="font-weight: 550">
              {{ user.firstname }} {{ user.surname }}
            </h6>

            <div class="my-3" style="font-size: 12px">
              <div class="row">
                <div class="col-6 text-end fw-bold pe-0 text-secondary">
                  Matriculation No
                </div>
                <div class="col-6 text-start">{{ user.matricno }}</div>
              </div>
              <div class="row">
                <div class="col-6 text-end fw-bold pe-0 text-secondary">
                  Department
                </div>
                <div class="col-6 text-start">
                  {{ user.program.replace(/.*\((.*)\)/, "$1") }}
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-end fw-bold pe-0 text-secondary">
                  Faculty
                </div>
                <div class="col-6 text-start"></div>
              </div>
              <div class="row">
                <div class="col-6 text-end fw-bold pe-0 text-secondary">
                  Student Email
                </div>
                <div class="col-6 text-start">
                  {{ user.email }}
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-end fw-bold pe-0 text-secondary">
                  Phone
                </div>
                <div class="col-6 text-start">{{ user.phone }}</div>
              </div>
            </div>
            <div class="gpa-section my-3" style="font-size: 12px">
              <span class="text-secondary fw-bold">GPA:</span>
              <i class="bi bi-eye-slash-fill"></i>
              <span class="ms-2">Degree Credits: <span>32/150</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <h6>E-mail</h6>
        <div class="card border-0 shadow-sm" style="min-height: 400px">
          <div
            class="card-header bg-white border-bottom-0"
            style="font-size: small"
          >
            <ul
              class="nav nav-pills mb-3 bg-body-secondary rounded-4 d-flex w-100"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link active w-100 rounded-4"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  Inbox
                </button>
              </li>
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100 rounded-4"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Sent
                </button>
              </li>
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100 rounded-4"
                  id="pills-contact-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-contact"
                  type="button"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                >
                  Starred
                </button>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabindex="0"
              >
                A
              </div>
              <div
                class="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
                tabindex="0"
              >
                B
              </div>
              <div
                class="tab-pane fade"
                id="pills-contact"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
                tabindex="0"
              >
                C
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <h6>Schedule</h6>
        <div class="card border-0 shadow-sm" style="min-height: 400px">
          <div class="card-body">
            <h6 class="fw-bold">Today</h6>
            <h6 class="fw-bold">Tomorrow</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-md-6">
        <h6>Upcoming Events</h6>
        <div
          class="card border-0 shadow-sm overflow-scroll"
          style="max-height: 550px"
        >
          <div v-for="(event, index) in upcomingEvents" :key="index">
            <img
              :src="event.image"
              class="w-100"
              height="175"
              style="object-fit: cover"
              alt="Event img"
            />
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-8">
                  <h6 class="card-title fw-bold small m-0">
                    {{ event.title }}
                  </h6>
                  <p style="font-size: 12px">
                    <span class="fw-bold">Organizers: </span>
                    <span>{{ event.organizer }}</span>
                  </p>
                </div>
                <div
                  class="col-4 d-flex flex-column text-end"
                  style="font-size: 12px"
                >
                  <span class="fw-bold">{{ event.date }}</span>
                  <span>{{ event.time }}</span>
                  <span class="fw-bold">{{ event.venue }}</span>
                </div>
              </div>
            </div>
            <div class="card-footer bg-white border-top-0 text-end pt-0">
              <a href="#" class="text-body-secondary small">More Info</a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-5">
        <h6>Quick Links</h6>
        <div
          class="card border-0 shadow-sm p-4 overflow-auto"
          style="height: 250px"
        >
          <div class="d-flex flex-wrap gap-3 justify-content-center">
            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-person-badge fs-2"></i>
              <small>Print ID Card</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-map-fill fs-2"></i>
              <small>Campus Map</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-chat-text fs-2"></i>
              <small>Complaints</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-cash-coin fs-2"></i>
              <small>Payments</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-calendar-check fs-2"></i>
              <small>Appointments</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-table fs-2"></i>
              <small>TimeTable</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-award fs-2"></i>
              <small>Grades</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-file-earmark-text fs-2"></i>
              <small>Transcript</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-bar-chart fs-2"></i>
              <small>GP Projection</small>
            </button>

            <button
              class="btn btn-dark d-flex flex-column align-items-center justify-content-center p-3 quick-link"
            >
              <i class="bi bi-mortarboard fs-2"></i>
              <small>Scholarships</small>
            </button>
          </div>
        </div>
        <h6 class="mt-4">My Courses</h6>
        <div class="card border-0 shadow-sm" style="height: 250px">
          <div
            class="card-header fcp-bg-primary text-white d-flex justify-content-between align-items-center"
          >
            <div class="d-grid">
              <span>2nd Semester </span>
              <span>Courses</span>
            </div>
            <div>
              <button @click="addCourse" class="btn btn-light btn-sm me-3">
                Add
              </button>
              <button
                @click="removeCourse"
                class="btn btn-outline-light btn-sm"
              >
                Remove
              </button>
            </div>
          </div>
          <div class="card-body overflow-auto">
            <ul class="list-group">
              <li
                v-for="(course, index) in courses"
                :key="index"
                class="list-group-item d-flex border-0 border-bottom"
              >
                <div>
                  <p class="m-0">
                    <strong>Course Code:</strong>
                    <span class="fw-bold ms-1">{{ course.code }}</span>
                  </p>
                  <p class="m-0">
                    <strong>Course Title:</strong> {{ course.title }}
                  </p>
                  <p class="m-0">
                    <strong>Course Credit:</strong> {{ course.credit }}
                  </p>
                </div>
                <p class="fst-italic ms-auto fw-bold text-secondary">
                  {{ course.type }}
                </p>
                <hr />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.scrollable-events {
  max-height: 450px;
}

.quick-link {
  min-width: 100px;
  max-width: 100px;
  height: 100px;
}

.quick-link small {
  font-size: 11px;
  font-weight: 550;
}
</style>
